import React from "react";
import { EmblaOptionsType } from "embla-carousel";
// import { DotButton, useDotButton } from "./Component-EmblaCarouselDotButton";
import {
    usePrevNextButtons,
    ReviewPrevButton,
    ReviewNextButton
} from "./Component-EmblaCarouselArrowButtons";
import useEmblaCarousel from "embla-carousel-react";
import styled from "styled-components";
import { theme } from "@/config/theme";
import { useTranslations } from "next-intl";
import imageFiveStars from "/public/media/images/image-fivestars.png";
import Image from "next/image";
import { StaticImport } from "next/dist/shared/lib/get-img-props";

interface Review {
    review: string;
    reviewer: string;
    country: string;
    flag: string | StaticImport;
}

type PropType = {
    // slides: number[];
    slides: Review[];
    options?: EmblaOptionsType;
};

const EmblaCarousel: React.FC<PropType> = (props) => {
    const { slides, options } = props;
    const [emblaRef, emblaApi] = useEmblaCarousel(options);

    // const { selectedIndex, scrollSnaps, onDotButtonClick } =
    //     useDotButton(emblaApi);

    const {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick
    } = usePrevNextButtons(emblaApi);

    const t = useTranslations("CustomerReviews");

    return (
        <div>
            <SCWrapper>
                <div className="text-container">
                    <div className="text-largexlarge">{t("title-text")}</div>
                    <div className="text-medium">{t("description-text")}</div>
                </div>
                <div className="embla__controls">
                    <div className="embla__buttons">
                        <ReviewPrevButton
                            onClick={onPrevButtonClick}
                            disabled={prevBtnDisabled}
                        />
                        <ReviewNextButton
                            onClick={onNextButtonClick}
                            disabled={nextBtnDisabled}
                        />
                    </div>
                </div>
            </SCWrapper>
            <SCEmbla>
                <section className="embla">
                    <div className="embla__viewport" ref={emblaRef}>
                        <div className="embla__container">
                            {slides.map((item, index) => (
                                <div className="embla__slide" key={index}>
                                    <div className="text-review">
                                        <Image
                                            src={imageFiveStars}
                                            alt="Five Stars"
                                        />
                                        <br />
                                        <br />
                                        {item.review}
                                    </div>
                                    <div className="reviewer-container">
                                        <div className="text-reviewer">
                                            {item.reviewer}
                                            <div className="text-review">
                                                {item.country}
                                            </div>
                                        </div>
                                        <div className="image-reviewer">
                                            <Image src={item.flag} alt="flag" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* <div className="embla__controls">
                        <div className="embla__buttons">
                            <PrevButton
                                onClick={onPrevButtonClick}
                                disabled={prevBtnDisabled}
                            />
                            <NextButton
                                onClick={onNextButtonClick}
                                disabled={nextBtnDisabled}
                            />
                        </div>

                        <div className="embla__dots">
                            {scrollSnaps.map((_, index) => (
                                <DotButton
                                    key={index}
                                    onClick={() => onDotButtonClick(index)}
                                    className={"embla__dot".concat(
                                        index === selectedIndex
                                            ? " embla__dot--selected"
                                            : ""
                                    )}
                                />
                            ))}
                        </div>
                    </div> */}
                </section>
            </SCEmbla>
        </div>
    );
};

export default EmblaCarousel;

const SCWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    --text-body: rgb(54, 49, 61);
    --text-high-contrast-rgb-value: 49, 49, 49;
    --detail-medium-contrast: rgb(234, 234, 234);

    .text-container {
        .text-largexlarge {
            font-size: ${theme["fontsize-lxl"]};
            font-weight: 500;
            margin-bottom: ${theme["spacing-m"]};
        }

        .text-medium {
            font-size: ${theme["fontsize-m"]};
            color: ${theme["color-grey"]};
        }
    }

    .embla__controls {
        display: grid;
        grid-template-columns: auto 1fr;
        justify-content: space-between;
        // gap: 1.2rem;
        // margin-top: 1.8rem;
    }
    .embla__buttons {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.6rem;
        align-items: center;
    }
    .embla__button {
        -webkit-tap-highlight-color: rgba(
            var(--text-high-contrast-rgb-value),
            0.5
        );
        -webkit-appearance: none;
        appearance: none;
        background-color: white;
        touch-action: manipulation;
        display: inline-flex;
        text-decoration: none;
        cursor: pointer;
        border: 0;
        padding: 0;
        margin: 0;
        // box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
        width: 3.6rem;
        height: 3.6rem;
        z-index: 1;
        // border-radius: 50%;
        border-radius: 10px;
        color: var(--text-body);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .embla__button:disabled {
        color: var(--detail-high-contrast);
    }
    .embla__button__svg {
        width: 35%;
        height: 35%;
    }
`;

const SCEmbla = styled.div`
    .embla {
        // max-width: 70rem;
        margin: auto;
        // --slide-height: 19rem;
        --slide-height: 22rem;
        --slide-spacing: 1rem;
        --slide-size: 100%;
        --slide-spacing-sm: 1.6rem;
        --slide-size-sm: 50%;
        --slide-spacing-lg: 2rem;
        --slide-size-lg: calc(100% / 3);

        --text-body: rgb(54, 49, 61);
        --text-high-contrast-rgb-value: 49, 49, 49;
        --detail-medium-contrast: rgb(234, 234, 234);
    }
    .embla__viewport {
        overflow: hidden;
    }
    .embla__container {
        backface-visibility: hidden;
        display: flex;
        touch-action: pan-y pinch-zoom;
        // margin-left: calc(var(--slide-spacing) * -1);
    }
    @media screen and (min-width: 750px) {
        .embla__container {
            // margin-left: calc(var(--slide-spacing-sm) * -1);
        }
    }
    @media screen and (min-width: 1200px) {
        .embla__container {
            // margin-left: calc(var(--slide-spacing-lg) * -1);
        }
    }
    .embla__slide {
        min-width: 0;
        min-height: 280px;
        flex: 0 0 var(--slide-size);
        // padding-left: var(--slide-spacing);
        padding: var(--slide-spacing);
        margin-left: ${theme["spacing-ml"]};
        background-color: ${theme["color-white"]};
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .reviewer-container {
            margin-top: ${theme["spacing-ml"]};
            display: flex;
            justify-content: space-between;

            .text-review {
                font-size: ${theme["fontsize-s"]};
                font-weight: 400;
                color: ${theme["color-grey"]};
            }

            .text-reviewer {
                font-weight: 500;
            }

            .image-reviewer img {
                width: auto;
                height: 35px;
            }
        }
    }
    @media screen and (min-width: 750px) {
        .embla__slide {
            flex: 0 0 var(--slide-size-sm);
            padding-left: var(--slide-spacing-sm);
        }
    }
    @media screen and (min-width: 1200px) {
        .embla__slide {
            flex: 0 0 var(--slide-size-lg);
            padding-left: var(--slide-spacing-lg);
        }
    }
    // .embla__slide__number {
    //     box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
    //     border-radius: 1.8rem;
    //     font-size: 4rem;
    //     font-weight: 600;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     height: var(--slide-height);
    //     user-select: none;
    // }
    .embla__controls {
        display: grid;
        grid-template-columns: auto 1fr;
        justify-content: space-between;
        gap: 1.2rem;
        margin-top: 1.8rem;
    }
    .embla__buttons {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.6rem;
        align-items: center;
    }
    .embla__button {
        -webkit-tap-highlight-color: rgba(
            var(--text-high-contrast-rgb-value),
            0.5
        );
        -webkit-appearance: none;
        appearance: none;
        background-color: transparent;
        touch-action: manipulation;
        display: inline-flex;
        text-decoration: none;
        cursor: pointer;
        border: 0;
        padding: 0;
        margin: 0;
        box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
        width: 3.6rem;
        height: 3.6rem;
        z-index: 1;
        border-radius: 50%;
        color: var(--text-body);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .embla__button:disabled {
        color: var(--detail-high-contrast);
    }
    .embla__button__svg {
        width: 35%;
        height: 35%;
    }
    .embla__dots {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: center;
        margin-right: calc((2.6rem - 1.4rem) / 2 * -1);
    }
    .embla__dot {
        -webkit-tap-highlight-color: rgba(
            var(--text-high-contrast-rgb-value),
            0.5
        );
        -webkit-appearance: none;
        appearance: none;
        background-color: transparent;
        touch-action: manipulation;
        display: inline-flex;
        text-decoration: none;
        cursor: pointer;
        border: 0;
        padding: 0;
        margin: 0;
        width: 2.6rem;
        height: 2.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
    }
    .embla__dot:after {
        box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
        width: 1.4rem;
        height: 1.4rem;
        border-radius: 50%;
        display: flex;
        content: "";
    }
    .embla__dot--selected:after {
        box-shadow: inset 0 0 0 0.2rem var(--text-body);
    }
`;
